export default "/images/vendor/flag-icon-css/flags/4x3/cw.svg?8e4cecbf86c9e4b2df3ae368ef68cdd2";